var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgComments(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "comments_a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "translate(914 633)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "comments_b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 17,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-914 -633)",
    clipPath: "url(#comments_a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(916 636)",
    clipPath: "url(#comments_b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,0C4.477,0,0,3.582,0,8a7.473,7.473,0,0,0,3.585,6.136.6.6,0,0,1-.062,1.037,8.052,8.052,0,0,1-1.024.419.6.6,0,0,0,.075,1.168A12.253,12.253,0,0,0,5,17a10.372,10.372,0,0,0,4.626-1.015c.125,0,.248.015.374.015,5.523,0,10-3.582,10-8S15.523,0,10,0M4.5,9.5A1.5,1.5,0,1,1,6,8,1.5,1.5,0,0,1,4.5,9.5m5.387,0a1.5,1.5,0,1,1,1.5-1.5,1.5,1.5,0,0,1-1.5,1.5m5.613,0A1.5,1.5,0,1,1,17,8a1.5,1.5,0,0,1-1.5,1.5",
    fill: "#1885f2"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComments);
export default __webpack_public_path__ + "static/media/comments.300f88831ed3cc561f502c3e6267e4c5.svg";
export { ForwardRef as ReactComponent };